import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import Imagic from "../../../components/imagic/imagic";

interface ImageSrcProps {
    src: string;
    width: number;
    height: number;
    showImage?: boolean; 
    priority?: boolean;
    objectFit?: any;
    objectPosition?: any; 
    onNextSource: (nextSrc: string) => void;
}

function ImageSrc ({src, height, width, showImage, priority, onNextSource, objectFit, objectPosition}: ImageSrcProps) {
    const [initialized, setInitialized] = useState(false);
    const divElement = useRef<HTMLDivElement>();
    function loadHandler(this: HTMLImageElement, ev: Event) {
        const nextSrc = this.getAttribute("src");
        if (nextSrc.startsWith("/_next/image")) {
            setInitialized(true);
            onNextSource(nextSrc);
        }
    }

    
    useEffect(() => {
        // console.log("image src: ", src);
        
        setInitialized(false);
        if (!divElement.current) return;
        const imgElement = divElement.current.children[0].children[1] as HTMLImageElement;
        imgElement.addEventListener("load", loadHandler);
        return () => imgElement.removeEventListener("load", loadHandler);
    }, [divElement.current, src])


    return !initialized ? 
    <div ref={divElement} style={{opacity: 0.01}}>
        <Image src={src} width={width} height={height} priority={priority} objectFit={objectFit} objectPosition={objectPosition}/>
    </div> : null;
}

export default ImageSrc;